export const upsertSubject = /* GraphQL */ `
  mutation UpsertSubject(
    $captcha_token: String
    $input: UpsertSubjectInput!
    $input_delete: [UpsertSubjectDeleteInput]
    $input_integrations: UpsertSubjectIntegrationsInput
  ) {
    upsertSubject(
      captcha_token: $captcha_token
      input: $input
      input_delete: $input_delete
      input_integrations: $input_integrations
    ) {
      total_count
    }
  }
`;
